/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetEndOfDayRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetEndOfDayRequests",
      data?.pageNumber,
      data?.operationDate,
      data?.cashCenterId,
      data?.operationDate,
    ],
    queryFn: () => client(`daily/operations/open/requests`, { data }),
  });

export const useChangeOperationalWindow = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/add/operational/window`, {
        data,
        successMessage: "Operations window changed successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetEndOfDayRequests"] });
    },
  });
};

export const useConfirmEndOfDay = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/confirm/end/of/day`, {
        data,
        successMessage: "End of day confirmed successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetEndOfDayRequests"] });
    },
  });
};
